import RoomLoading from './RoomLoading';

export default RoomLoading;
